import { Button, Box, Card, Tabs, Tab, CardContent, Divider, Link } from '@material-ui/core';
import React, { useRef, useState} from 'react';


import 'react-toastify/dist/ReactToastify.css';

import TextField from '@material-ui/core/TextField';
import { Typography } from '@material-ui/core';

import CircularProgress from '@material-ui/core/CircularProgress';


import MUIDataTable from "mui-datatables";



const API_TOKEN = "2b0019cc43f5e0653066"; 

const API_BASE = "http://mobileappscrapper.herokuapp.com/js/https://open.sincera.io/api";

function prettyKey(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

function renderObj(obj, depth = 0) {
  if (obj === null || obj === undefined)
    return <Typography color="text.secondary" fontStyle="italic">None</Typography>;
  if (typeof obj !== "object" || obj instanceof Date)
    return <Typography component="span">{String(obj)}</Typography>;
  if (Array.isArray(obj)) {
    if (obj.length === 0)
      return <Typography color="text.secondary" fontStyle="italic">[]</Typography>;
    return (
      <Box sx={{ ml: 2, borderLeft: "2px solid #eee", pl: 2 }}>
        {obj.map((item, idx) => (
          <Box key={idx} sx={{ mb: 0.5 }}>{renderObj(item, depth + 1)}</Box>
        ))}
      </Box>
    );
  }
  // Flat object: use Definition List for good look
  return (
    <Box component="dl" sx={{ mt: 0, mb: 0 }}>
      {Object.entries(obj).map(([k, v]) => (
        <Box key={k} sx={{ mb: 2 }}>
          <Typography component="dt" variant="subtitle2" color="primary">{prettyKey(k)}</Typography>
          <Typography component="dd" sx={{ ml: 1 }}>{renderObj(v, depth + 1)}</Typography>
        </Box>
      ))}
    </Box>
  );
}

const OpenSinceraExplorer = () => {
  const [mode, setMode] = useState("ecosystem");
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  const fetchData = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setData(null);
    setError("");
    let url = "";

    if (mode === "ecosystem") {
      url = `${API_BASE}/ecosystem`;
    } else if (mode === "publisherId") {
      url = `${API_BASE}/publishers?id=${input.trim()}`;
    } else if (mode === "publisherDomain") {
      url = `${API_BASE}/publishers?domain=${input.trim()}`;
    }

    try {
      const resp = await fetch(url, {
        headers: { Authorization: `Bearer ${API_TOKEN}` },
      });

      let json = null;
      try {
        json = await resp.json();
      } catch {
        // Not JSON, could be 500 error or empty
        json = null;
      }

      if (resp.status === 404) {
        setError("No results found for this query.");
      } else if (!resp.ok) {
        // Try to use the error message from the API, or fallback
        setError(json && json.error ? String(json.error) : "Something went wrong. Please check the API or try again later.");
      } else if (json && json.error) {
        setError(String(json.error));
      } else {
        setData(json);
      }
    } catch (err) {
      setError("Failed to fetch data. Please check your network.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      maxWidth={650}
      mx="auto"
      my={6}
      p={{ xs: 2, md: 4 }}
      component={Card}
      elevation={6}
      borderRadius={4}
    >
      <Typography variant="h4" mb={2} color="primary" fontWeight={700}>
        OpenSincera API Explorer
      </Typography>

      <Tabs
        value={mode}
        onChange={(_, val) => {
          setMode(val);
          setInput("");
          setData(null);
          setError("");
        }}
        variant="fullWidth"
        sx={{ mb: 3 }}
      >
        <Tab value="ecosystem" label="Ecosystem Data" />
        <Tab value="publisherId" label="Publisher by ID" />
        <Tab value="publisherDomain" label="Publisher by Domain" />
      </Tabs>

      {/* Input Form */}
      <Box component="form" onSubmit={fetchData} mb={3}>
        {(mode === "publisherId" || mode === "publisherDomain") && (
          <TextField
            label={mode === "publisherId" ? "Publisher ID" : "Publisher Domain"}
            placeholder={mode === "publisherId" ? "e.g. 1" : "e.g. businessinsider.com"}
            variant="outlined"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            fullWidth
            required
            sx={{ mb: 2 }}
          />
        )}
        {(mode === "publisherId" || mode === "publisherDomain") ? (
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            fullWidth
            size="large"
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Search"}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            fullWidth
            size="large"
            onClick={fetchData}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Get Ecosystem Data"}
          </Button>
        )}
      </Box>

      {/* Output */}
      {(error) && (

          {error}

      )}
      {loading && (
        <Box textAlign="center" my={3}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {data && !error && (
        <Card variant="outlined" sx={{ mb: 2, bgcolor: "#f9fafe" }}>
          <CardContent>
            {renderObj(data)}
          </CardContent>
        </Card>
      )}

      <Divider sx={{ my: 3 }} />

      <Typography variant="body2" color="text.secondary" align="center">
        Data powered by{" "}
        <Link href="https://open.sincera.io" target="_blank" rel="noopener">
          OpenSincera
        </Link>
        .
      </Typography>
    </Box>
  );
}

export default function JsonExporter() {

  const tableRef = useRef();
  const json = useRef()
  const jsonik = useRef();
  const wynik = useRef()
  const [datatableData,setdatatableData] = useState([]);
  const [datatableData2,setdatatableData2] = useState([]);
  const [datatableData3,setdatatableData3] = useState([]);
  const [datatableData4,setdatatableData4] = useState([]);
  var JsonLines = [];
  var Errors = [];
  var text;
  var names = [];
  var domains = [];
  var countdomains = {};
  var publisher = [];
  var counttypes = {};
  var idcount = [];
  var countids = {};
  var count = {};
  var duplicate = [{}];
  var duplicatedomains = [{}];
  var duplicateids = [{}];
  var jsonstrict;

  function Check()
  {
    try
    {
    jsonstrict = json.current.value;
    console.log(JSON.parse(jsonstrict))
    Action()
    }
    catch
    {
      let error = "It is not valid Json file!";
      wynik.current.innerHTML = "<b style='color:red''>" + error + "</b>";
    }
  }

    function validatejson()
    {
      var RawJson = jsonik.current.value;
      var RemovedSellers = RawJson.split('sellers": [').pop();
      var SemiLines = RemovedSellers.replaceAll("\n      ", "")
      SemiLines = SemiLines.replaceAll("    ","")
      var SemiSemiLines = SemiLines.replaceAll("\n", "")
      var Lines = SemiSemiLines.split("},");
      try
      {
        JSON.parse(RawJson)
      }
      catch(e)
      {
        console.log("Sellers.json could not be parsed. Consider fixing errors and try again!")
      }
      //var Lines2 = Lines.split(/{|}/);
      
      
      for(let element in Lines)
      {
        try{
          if(Lines[element].endsWith("]"))
          {
            Lines[element] = Lines[element].slice(0,-1);
          }
          if(!Lines[element].endsWith("}"))
          {
            Lines[element] += "}"
          }
          if(Lines[element].endsWith('"1.0"}'))
          {
            Lines[element] = Lines[element].split(']')[0]
          }
          if(Lines[element].endsWith('}  ]}'))
          {
            Lines[element] = Lines[element].split(']')[0]
          }
          Lines[element] = JSON.parse(Lines[element])
          JsonLines[element] = Lines[element]
        }
        catch(e)
        {
          console.log(e.message)
          Errors[element] = Lines[element] + " " + e.message;
        }
        for(let elements in JsonLines)
        {
          try
          {
            if (JsonLines[elements].name === "" || JsonLines[elements].name === undefined || JsonLines[elements].name === null)
            {
              if (Number(JsonLines[elements].is_confidential) === 0)
              {
                Errors[elements] = JsonLines[elements].seller_id + " Seller_name is missing!"
              }
              else
              {

              }
              
            }
          }
          catch
          {
            try
            {
              if (Number(JsonLines[elements].is_confidential) === 0)
              {
                Errors[elements] = JsonLines[elements].seller_id + " Seller_name is missing!"
              }
              
            }
            catch
            {
              if (Number(JsonLines[elements].is_confidential) === 0)
              {
                Errors[elements] = JsonLines[elements].domain + " Seller_name is missing!"
              }
              
            }
            
          }
          try
          {
            if (JsonLines[elements].seller_type.toLowerCase() === "intermediary" || JsonLines[elements].seller_type.toLowerCase() === "both" || JsonLines[elements].seller_type.toLowerCase() === "publisher")
            {
              
            }
            else
            {
              try
              {
                Errors[elements] = JsonLines[elements].seller_id + " Seller type is invalid or empty!"
              }
              catch
              {
                Errors[elements] = JsonLines[elements].seller_name + " Seller type is invalid or empty!"
              }
              
            }
          }
          catch
          {
            Errors[elements] = JsonLines[elements].seller_id + " Seller type is invalid or empty!"
          }
          
          if (Number(JsonLines[elements].is_confidential) === 0)
          {
            try
            {
              if (JsonLines[elements].domain === undefined || JsonLines[elements].domain === null || JsonLines[elements].domain === "")
              {
                Errors[elements] = "Seller_ID: " + JsonLines[elements].seller_id + " Sellers.json is not confidential but domain is missing!"
              }
              
            }
            catch
            {
              Errors[elements] = "Sellers.json is not confidential but domain is missing!"
            }
            
          }
          try
          {
            if (JsonLines[elements].seller_id === "" || JsonLines[elements].seller_id === undefined || JsonLines[elements].seller_id === null)
            {
              Errors[elements] = JsonLines[elements].name + " Seller_id is missing!"
            }
          }
          catch
          {
            try
            {
              Errors[elements] = JsonLines[elements].name + " Seller_id is missing!"
            }
            catch
            {
              Errors[elements] = JsonLines[elements].domain + " Seller_id is missing!"
            }
            
          }
        }
        
        
      }
      
      console.log(JsonLines);

      console.log(Errors.filter(n => n));
    }
    function Action()
    {

      wynik.current.innerHTML = "";
      setdatatableData('');
      setdatatableData2('');
      setdatatableData3('');
      setdatatableData4('');

      jsonstrict = json.current.value;
      
      
      for(let a = 0; a<JSON.parse(jsonstrict).sellers.length; a++)
      {
        names.push(JSON.parse(jsonstrict).sellers[a].name);
        domains.push(JSON.parse(jsonstrict).sellers[a].domain);
        publisher.push(JSON.parse(jsonstrict).sellers[a].seller_type);
        idcount.push(JSON.parse(jsonstrict).sellers[a].seller_id)
      }
      
    names.forEach((i) => { count[i] = ++count[i]|| 1});
    domains.forEach((i) => { countdomains[i] = ++countdomains[i]|| 1});
    publisher.forEach((i) => { counttypes[i] = ++counttypes[i]|| 1});
    idcount.forEach((i) => { countids[i] = ++countids[i]|| 1});
    console.log(countids);
    var i = 0;
    for (const [key, value] of Object.entries(count)) {
      
      duplicate[i] = {
        "id":i,
        "Company":key,
        "Instances":value
      }
      i++;
    }
    var k = 0;
    for (const [key, value] of Object.entries(countdomains)) {
      
      duplicatedomains[k] = {
        "id":k,
        "Domain":key,
        "Instances":value
      }
      k++;
    }
    var j = 0;
    for (const [key, value] of Object.entries(countids)) {
      
     duplicateids[j] = {
       "id":key,
       "Instances":value
     }
     j++;
   }

  
    for(let element in duplicateids)
    {
      setdatatableData4(datatableData4 => [...datatableData4,[duplicateids[element].id, duplicateids[element].Instances]])
    }
    for(let element in duplicate)
    {
      setdatatableData(datatableData => [...datatableData,[duplicate[element].Company, duplicate[element].Instances]])
    }
    for(let element in duplicatedomains)
    {
      setdatatableData2(datatableData2 => [...datatableData2,[duplicatedomains[element].Domain, duplicatedomains[element].Instances]])
    }

      setdatatableData3(datatableData3 => [...datatableData3,["PUBLISHER", counttypes.PUBLISHER]]);
      setdatatableData3(datatableData3 => [...datatableData3,["INTERMEDIARY", counttypes.INTERMEDIARY]]);
      setdatatableData3(datatableData3 => [...datatableData3,["BOTH", counttypes.BOTH]]);
    
        console.log(duplicate);
    //wynik.current.innerText = text;

      //$.get("https://mobileappscrapper.herokuapp.com/text/" + jsonstrict, function (data) {
        
  }


    
    function ExportSellers()
    {
      wynik.current.innerHTML = "";
      var jsonstrict = json.current.value;
      var jsonstrict2 = jsonstrict.replace(/&#39;/g, "");
      var jsonstrict3 = jsonstrict2.replace(/#/g, "");
      try
      {
      var json2 = JSON.parse(jsonstrict3)
      //text = objectsToCSV(json2.sellers);
      var newObj = []
      for(let element in json2.sellers)
      {
        newObj[element] = {
          "seller_id":json2.sellers[element].seller_id,
          "is_confidential":json2.sellers[element].is_confidential,
          "seller_type":json2.sellers[element].seller_type,
          "is_passthrough":json2.sellers[element].is_passthrough,
          "name":json2.sellers[element].name,
          "domain":json2.sellers[element].domain,
          "comment":json2.sellers[element].comment,
          "ext": json2.sellers[element].ext
        }
      }
      text = objectsToCSV(newObj);
      //wynik.current.innerText = text;
       download_txt();
      }
      catch
      {
        let error = "It is not valid Json file!";
        wynik.current.innerHTML = "<b style='color:red''>" + error + "</b>";
      }
    
    }
    function objectsToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)
      return array.map(row => {
          return Object.values(row).map(value => {
              return typeof value === 'string' ? JSON.stringify(value) : value
          }).toString()
      }).join('\n')
  }
  function download_txt() {
    var textToSave = text;
  var hiddenElement = document.createElement('a');

  hiddenElement.href = 'data:attachment/text,' + encodeURI(textToSave);
  hiddenElement.target = '_blank';
  hiddenElement.download = 'Json.csv';
  hiddenElement.click();
}
  
return (
    <div >
      <br></br>
       <TextField variant="outlined" multiline inputRef={json} rows={10} placeholder="Insert valid SELLERS.JSON file text" id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"300px",resize:"vertical"}} className="inline-txtarea"></TextField>
       
    <br></br>
    <Button variant="contained" color="primary" onClick={Check}>Check Sellers.json</Button>
    <Button variant="contained" color="primary" onClick={ExportSellers}>Export Sellers</Button>

    <p> </p>
    <div ref={wynik}>

    </div>
    <MUIDataTable
            
            title="Seller type"
            ref={tableRef}
            columns={["Type", {name:"Instances",label:"Instances",options: {
              filter: true,
              sort: true,
              sortDirection: 'desc',
          }}]}
            data={datatableData3}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'SellersJSON_SellerTypes' + new Date().toISOString().slice(0, 10) + '.csv'
              },
              sort: true,
              sortDirection: 'desc',
              textLabels: {
                body: {
                  noMatch: "Please check sellers.json first",
                }},
            }}
            
          />
          <MUIDataTable
            
            title="Seller id"
            ref={tableRef}
            columns={["Id", {name:"Instances",label:"Instances",options: {
              filter: true,
              sort: true,
              sortDirection: 'desc',
          }}]}
            data={datatableData4}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'SellersJSON_SellerIds' + new Date().toISOString().slice(0, 10) + '.csv'
              },
              sort: true,
              sortDirection: 'desc',
              textLabels: {
                body: {
                  noMatch: "Please check sellers.json first",
                }},
            }}
            
          />
    <MUIDataTable
            
            title="Company count"
            ref={tableRef}
            columns={["Company", {name:"Instances",label:"Instances",options: {
              filter: true,
              sort: true,
              sortDirection: 'desc',
          }}]}
            data={datatableData}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'SellersJson_CompanyCount' + new Date().toISOString().slice(0, 10) + '.csv'
              },
              sort: true,
              sortDirection: 'desc',
              textLabels: {
                body: {
                  noMatch: "Please check sellers.json first",
                }},
            }}
            
          />
          <MUIDataTable
            
            title="Domain count"
            ref={tableRef}
            columns={[{name:"Domain", label:"Domain"}, {name:"Instances",label:"Instances",options: {
              filter: true,
              sort: true,
              sortDirection: 'desc',
          }}]}
            data={datatableData2}
            options={{
              filterType: "checkbox",
              downloadOptions: {
                filename: 'SellersJson_DomainCount' + new Date().toISOString().slice(0, 10) + '.csv'
              },
              textLabels: {
                body: {
                  noMatch: "Please check sellers.json first",
                }},
            }}
            
          />
          <TextField variant="outlined" multiline inputRef={jsonik} rows={10} placeholder="Insert valid SELLERS.JSON file text" id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"300px",resize:"vertical"}} className="inline-txtarea"></TextField>
          <Button variant="contained" color="primary" onClick={validatejson}>Validate</Button>

          <OpenSinceraExplorer></OpenSinceraExplorer>
    </div>
);
}
